import React, { useEffect, useState } from "react";
import { Flame, Eye, Heart, TrendingUp } from "lucide-react";
import api from "@/lib/api";
import VideoCard from "@/components/VideoCard";

const SECTIONS = [
  { k: "today", label: "Most Viewed Today", Icon: Flame },
  { k: "week", label: "This Week", Icon: TrendingUp },
  { k: "most_liked", label: "Most Liked", Icon: Heart },
  { k: "recent_popular", label: "Recently Popular", Icon: Eye },
];

export default function Trending() {
  const [sec, setSec] = useState("today");
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    api.get("/trending", { params: { section: sec, limit: 16 } }).then((r) => setVideos(r.data)).catch(() => setVideos([]));
  }, [sec]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="trending-page">
      <div className="mb-8">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#FF9F0A] font-bold">Hot Right Now</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black mt-2">Trending</h1>
      </div>

      <div className="flex flex-wrap gap-2 mb-8">
        {SECTIONS.map((s) => (
          <button key={s.k}
            data-testid={`trend-tab-${s.k}`}
            onClick={() => setSec(s.k)}
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-widest border transition-all ${
              sec === s.k ? "bg-[#E50914] border-[#E50914] text-white shadow-[0_0_20px_rgba(229,9,20,0.4)]" : "bg-white/5 border-white/10 text-zinc-400 hover:text-white"
            }`}>
            <s.Icon className="w-3.5 h-3.5" /> {s.label}
          </button>
        ))}
      </div>

      {videos.length === 0 ? (
        <div className="text-center py-16 text-zinc-500 text-sm">Not enough activity yet in this window. Check back soon.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {videos.map((v) => <VideoCard key={v.id} video={v} />)}
        </div>
      )}
    </div>
  );
}
